module.exports = __webpack_public_path__ + "img/left_right_layout_4.78a33d3f.svg";